import React from 'react'

export default function Footer() {
    return (
        <nav className='text-center text-[#EDD2E0]'>
            <div className='items-center justify-center bg-[#7A52A3]  text-[24px] font-normal'>
                Made for weather updates being handy
            </div>
        </nav>
    )
}
